/*
 * HONEYWELL INC.,
 * COPYRIGHT (c) 2022
 * ALL RIGHTS RESERVED
 *
 * This software is a copyrighted work and/or information protected as a trade secret.
 * Legal rights of Honeywell Inc. in this software is distinct from ownership of any medium
 * in which the software is embodied. Copyright or trade secret notices included must be
 * reproduced in any copies authorized by Honeywell Inc.
 *
 */

import React, { useEffect } from 'react';
import { useTranslation } from '@scuf/localization';
import descriptors from '../../../../locales/en-US/descriptors';
import IEnergyManagementProps from '../../../DashboardKPIWidgets/IEnergyManagementProps';
import UtilityBillPerformanceDetailComponent from '../../UtilityBillPerformanceDetailWidget/UtilityBillPerformanceDetailWidget';
import SavingsByMeterComponent from '../../SavingsByMeterWidget/SavingsByMeterComponent';
import useConnectorAndDynamicProps from '../../../shared/useConnectorAndDynamicProps/useConnectorAndDynamicProps';
import useMounted from '../../../shared/useMount/useMount';
import {
  excludeCurrentMonth,
  getFirstDayofSelectedMonth
} from '../../../shared/Utils/Utils';
import { UtilityType } from '../../../shared/Utils/Constants';
import { getConnctorConfig } from '../../../shared/Utils/DataConnectorUtils';

const WindSavingsDetailComponent = (props: IEnergyManagementProps) => {
  const [t] = useTranslation();
  const d = descriptors.energyManagement;
  const { bearerToken, requestContext } = props;

  const startDate = getFirstDayofSelectedMonth(
    requestContext.context.startTime!
  );
  const endDate = excludeCurrentMonth(
    requestContext.context.endTime!,
    requestContext.context.startTime!
  );
  const connectorConfig = getConnctorConfig(
    'utility-sewerage',
    requestContext,
    startDate,
    endDate
  );

  const isMounted = useMounted();

  const [dataConnector] = useConnectorAndDynamicProps({
    connectorConfig,
    requestContext,
    bearerToken
  });

  const commonProps = {
    performanceHeading: t(d.WINDPERFORMANCE)
  };

  useEffect(() => {
    if (isMounted) {
      dataConnector && dataConnector.actions && dataConnector.actions.getAll();
    }
  }, [requestContext]);

  const UtilityBillType = UtilityType.Sewerage;
  return (
    <div>
      <UtilityBillPerformanceDetailComponent
        dataConnector={dataConnector}
        commonProps={commonProps}
      />
      <SavingsByMeterComponent
        dataConnector={dataConnector}
        UtilityBillType={UtilityBillType}
      />
    </div>
  );
};
export default WindSavingsDetailComponent;
